.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-4);
}

.pickers {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
}

.picker {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  border: none;
  padding: 0;
  margin: 0;
}

.pickerLegend {
  font-weight: 600;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.pickerButtons {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
}

.comparison {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--tuna-spacing-4);
}

.voicingCard {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-subtle, var(--tuna-palette-grey-300));
  border-radius: var(--tuna-shape-borderRadius);
  padding: var(--tuna-spacing-3);
}

.voicingHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.voicingTitle {
  font-weight: 600;
}

.scoreBadge {
  font-family: var(--tuna-typography-mono-fontFamily, monospace);
  font-weight: 700;
  padding: 0 var(--tuna-spacing-1);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated, var(--tuna-palette-grey-100));
}

.breakdown {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.breakdownRow {
  display: flex;
  justify-content: space-between;
}

.breakdownRow dt {
  margin: 0;
}

.breakdownRow dd {
  margin: 0;
  font-variant-numeric: tabular-nums;
}

.breakdownCopy {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
  margin: 0;
}

@media (max-width: 599.95px) {
  .comparison {
    grid-template-columns: 1fr;
  }
}
